import { render, staticRenderFns } from "./InicioUno.vue?vue&type=template&id=66b6b8ee&scoped=true"
import script from "./InicioUno.vue?vue&type=script&lang=js"
export * from "./InicioUno.vue?vue&type=script&lang=js"
import style0 from "./InicioUno.vue?vue&type=style&index=0&id=66b6b8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b6b8ee",
  null
  
)

export default component.exports